import { Component, Inject } from '@angular/core';
import { ConfigService } from '@icc/shared';
import { DIALOG_DATA, DialogRef } from '@icc/ui';

type OrderPrintSettingsType =
  | 'printPdfExternalVenetianOrder'
  | 'printPdfRollerShutterOrder'
  | 'printPdfPleatedMosquitoScreenOrder';

type PrintSettingsType =
  | 'printPdf'
  | OrderPrintSettingsType
  | 'printPdfEmailLang'
  | 'printOrder';

interface OrderPrintOption {
  settingsType: OrderPrintSettingsType;
  label: string;
  currentLanguage: string | null;
}

@Component({
  selector: 'app-print-settings-dialog',
  templateUrl: './print-settings-dialog.component.html',
  styleUrls: ['./print-settings-dialog.component.scss']
})
export class PrintSettingsDialogComponent {

  printSettings = {
    settingsType: (this.data.settingsType === 'printOrder'
      ? this.data.orderPrintOptions?.[0]?.settingsType
      : this.data.settingsType) as PrintSettingsType,
    printLanguage: ''
  };

  constructor(
    @Inject(DIALOG_DATA)
    public data: {
      availableLanguages: {
        code: string;
        name: string;
      }[];
      currentLanguage: string | null;
      settingsType: PrintSettingsType;
      orderPrintOptions?: OrderPrintOption[];
    },
    private dialogRef: DialogRef,
    private configService: ConfigService,
  ) {
    this.printSettings.printLanguage = this.resolveCurrentLanguage();
  }

  private resolveCurrentLanguage() {
    if (this.data.settingsType === 'printOrder') {
      return this.data.orderPrintOptions?.find(
        option => option.settingsType === this.printSettings.settingsType
      )?.currentLanguage
        || this.configService.user.user.userBoxData.activeContentLanguage
        || this.configService.user.user.userBoxData.activeLanguage;
    }

    return this.data.currentLanguage
      || this.configService.user.user.userBoxData.activeContentLanguage
      || this.configService.user.user.userBoxData.activeLanguage;
  }

  save() {
    this.dialogRef.close(this.printSettings);
  }

  close() {
    this.dialogRef.close();
  }

  setCurrentPdfLanguage(code: string) {
    this.printSettings.printLanguage = code;
  }

  setOrderPrintType(settingsType: OrderPrintSettingsType) {
    this.printSettings.settingsType = settingsType;
    this.printSettings.printLanguage = this.resolveCurrentLanguage();
  }

}
